/**
 * Cliente HTTP de administración de envío (MVP-02C).
 *
 * Única puerta de entrada a `/shipping-admin/*`. Todas las mutaciones reales
 * viven en el backend (`store/shipping/services.py`); aquí solo se llama.
 */
import axios from "axios";

const BASE = "/shipping-admin";

export const fetchReadiness = () => axios.get(`${BASE}/readiness/`).then((r) => r.data);

// --- Direcciones --------------------------------------------------------

export const fetchAddresses = (kind) =>
    axios.get(`${BASE}/addresses/`, { params: kind ? { kind } : {} }).then((r) => r.data);
export const createAddress = (payload) =>
    axios.post(`${BASE}/addresses/`, payload).then((r) => r.data);
export const activateAddress = (id) =>
    axios.post(`${BASE}/addresses/${id}/activate/`).then((r) => r.data);

// --- Embalajes -----------------------------------------------------------

export const fetchPackagingProfiles = () =>
    axios.get(`${BASE}/packaging/`).then((r) => r.data);
export const createPackagingProfile = (payload) =>
    axios.post(`${BASE}/packaging/`, payload).then((r) => r.data);
export const updatePackagingProfile = (id, payload) =>
    axios.patch(`${BASE}/packaging/${id}/`, payload).then((r) => r.data);
export const duplicatePackagingProfile = (id) =>
    axios.post(`${BASE}/packaging/${id}/duplicate/`).then((r) => r.data);
export const setPackagingProfileActive = (id, isActive) =>
    axios.post(`${BASE}/packaging/${id}/activation/`, { is_active: isActive }).then((r) => r.data);

// --- Zonas -----------------------------------------------------------------

export const fetchZones = () => axios.get(`${BASE}/zones/`).then((r) => r.data);
export const createZone = (payload) => axios.post(`${BASE}/zones/`, payload).then((r) => r.data);
export const setZoneActive = (id, isActive) =>
    axios.post(`${BASE}/zones/${id}/toggle/`, { is_active: isActive }).then((r) => r.data);

// --- Tarifas -----------------------------------------------------------------

export const fetchTariffs = () => axios.get(`${BASE}/tariffs/`).then((r) => r.data);
export const createTariff = (payload) => axios.post(`${BASE}/tariffs/`, payload).then((r) => r.data);
export const updateTariffRates = (id, rates) =>
    axios.patch(`${BASE}/tariffs/${id}/rates/`, { rates }).then((r) => r.data);
export const activateTariff = (id) =>
    axios.post(`${BASE}/tariffs/${id}/activate/`).then((r) => r.data);

// --- Calendario -----------------------------------------------------------------

export const fetchWorkingWeeks = () => axios.get(`${BASE}/working-weeks/`).then((r) => r.data);
export const createWorkingWeek = (payload) =>
    axios.post(`${BASE}/working-weeks/`, payload).then((r) => r.data);
export const activateWorkingWeek = (id) =>
    axios.post(`${BASE}/working-weeks/${id}/activate/`).then((r) => r.data);

export const fetchCalendarExceptions = () =>
    axios.get(`${BASE}/calendar-exceptions/`).then((r) => r.data);
export const createCalendarException = (payload) =>
    axios.post(`${BASE}/calendar-exceptions/`, payload).then((r) => r.data);
export const toggleCalendarException = (id, isActive) =>
    axios.post(`${BASE}/calendar-exceptions/${id}/toggle/`, { is_active: isActive }).then((r) => r.data);

// --- Configuración -----------------------------------------------------------------

export const fetchShippingConfig = () => axios.get(`${BASE}/config/`).then((r) => r.data);
export const updateShippingConfig = (payload) =>
    axios.patch(`${BASE}/config/`, payload).then((r) => r.data);

// --- Simulador -----------------------------------------------------------------

export const simulateQuote = (payload) =>
    axios.post(`${BASE}/simulate/`, payload).then((r) => r.data);

// --- Errores -----------------------------------------------------------------

/** Aplana los errores del serializer/servicio a `{campo: mensaje}`.
 *
 * `non_field_errors` se mapea a `general` para que todos los consumidores
 * puedan usar el mismo campo sin distinción. */
export const parseAdminErrors = (error) => {
    const data = error?.response?.data;
    if (!data) return { general: "No se pudo completar la operación." };
    if (typeof data === "string") return { general: data };
    if (data.detail) return { general: data.detail };
    const result = {};
    for (const [campo, mensaje] of Object.entries(data)) {
        const key = campo === "non_field_errors" ? "general" : campo;
        const value = Array.isArray(mensaje) ? mensaje.join(" ") : String(mensaje);
        result[key] = result[key] ? `${result[key]} ${value}` : value;
    }
    return result;
};
